export default "__VITE_ASSET__DTX6bfw4__"